var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-main"},[_c('div',{staticClass:"hd-bg"}),_c('pageHeader'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }